export default "__VITE_ASSET__DAut3_Z6__"